/**
 * Revert aria-hidden
 */
/* istanbul ignore next @preserve */
function CloseDialog() {
    const { body } = document;
    const siblings = body.children;
    for (let i = 0; i < siblings.length; i++) {
        const sibling = siblings[i];
        if (sibling) {
            sibling.removeAttribute('data-old-aria-hidden');
            sibling.removeAttribute('aria-hidden');
            sibling.removeAttribute('inert');
        }
    }
}

export { CloseDialog as default };
